import { defineStore } from 'pinia';

export const useTableExpandedColumnsStore = defineStore('tableExpandedColumns', {
  state: (): { expandedColumns: Record<string, Record<string, boolean>> } => ({
    expandedColumns: {},
  }),
  actions: {
    setExpandedColumn(dataKey: string, columnField: string, isExpanded: boolean) {
      // Initialize the dataKey if not present
      if (!this.expandedColumns[dataKey]) {
        this.expandedColumns[dataKey] = {}; // Initialize as a nested object
      }
      // Set the expanded state for the specific column
      this.expandedColumns[dataKey][columnField] = isExpanded;
    },
    isColumnExpanded(dataKey: string, columnField: string) {
      // Return the expanded state for the column, default to false
      return this.expandedColumns[dataKey]?.[columnField] || false;
    },
  },
  persist: {
    storage: localStorage,
  },
});
